import WithdrawFormSkeleton from '../../pages/withdraw/withdraw-form-skeleton'
import classNames from '../../utils/classNames'

// Placeholder bar colour: contrasts against the modal surface in both themes
// (matches the other withdraw skeletons).
const bar = 'bg-secondary-txt-50 dark:bg-tertiary rounded'

// Tab-label widths roughly matching RETIRAR / LISTA DE BANCOS / AÑADIR BANCO /
// LISTA DE CRYPTO / AÑADIR CRYPTO.
const tabWidths = ['w-20', 'w-36', 'w-32', 'w-36', 'w-32']

// Suspense fallback for the lazy-loaded `Withdraw` chunk. It reproduces the
// `Withdraw` wrapper's padding, a skeleton tab bar, and the form skeleton so the
// first paint of the modal shows the real layout instead of a bare spinner and
// does not reflow once the chunk resolves.
const WithdrawModalSkeleton = () => (
  <div className="w-full pt-0 pb-6 px-6 xl:p-12">
    <div className="flex flex-wrap gap-3 mb-4 animate-pulse xl:gap-4 xl:mb-6">
      {tabWidths.map((w, i) => (
        <div key={i} className={classNames('h-5 xl:h-6', w, bar)} />
      ))}
    </div>
    <WithdrawFormSkeleton />
  </div>
)

export default WithdrawModalSkeleton
